import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import cs from 'classnames'
import css from './index.css'
import Button from '~/components/common/Button';
import {modalClose, modalChange} from '~/modules/modal/actions';
import { userDispatcher } from '~/misc/userAccount'
import * as modes from '~/modules/modal/modes';
import {push as changeURL} from 'react-router-redux';

class NotInNetwork extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const {closePop, gotoVerify } = this.props;
    return (
      <div className={css.popwrap}>
        <header className={css.title}>
          <p>Not in Network</p>
        </header>
        <main className={css.mainNormal}>
          For you to be able to book loads with us, you are required to become verified with us. We have saved this load for you in Saved loads section.
        </main>
        <footer className={css.footer}>
          <div className={css.footerRow}>
            <Button
              mods={['action']}
              className={css.button}
              onClick={()=>{
                gotoVerify();
                closePop();
              }}
            >
              Verify
            </Button>
          </div>
        </footer> 
      </div>
    )
  }
}

export default connect(null, mapDispatch({
  closePop: () => modalClose(modes.NOT_IN_NETWORK),
  gotoVerify:(props, url) => changeURL(userDispatcher())
}))(NotInNetwork);


// WEBPACK FOOTER //
// ./src/components/Popup/NotinNetwork/index.js